// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-tel-input .form-control {
  height: 2.5rem !important;
  width: 100% !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 6px !important;
}

.customTable th {
  background-color: #2d3748;
  color: white !important;
}

.ql-toolbar {
  border: none !important;
  background-color: #f9f9f9;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}
.ql-editor {
  height: 100%;
  min-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border: none;
}

.ql-editor > p > img {
  display: block !important;
  max-width: 100% !important;
  margin: auto !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.ql-container {
  border: none !important;
}

.ql-align-center {
  text-align: center !important;
}
.preview_blog_container > div > h2 {
  font-size: 1.2rem;
  font-weight: 500;
}

.preview_blog_container > div > blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}
.preview_blog_container > div > p > img {
  margin: auto !important;
}
.preview_blog_container > div > p,
h1,
h2 > img {
  margin: auto !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.preview_blog_container > div > pre {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
}

.preview_blog_container > div > .ql-syntax {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
  border-radius: 3px;
  font-size: 13px;
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.preview_blog_container > div > ul, ol {
  padding-left: 2.5em !important;
}

/* login page slider design */
.loginSlider .slick-slide div {
  height: 100%;
  padding: 0;
}
.loginSlider .slick-slider{
  height: 100%;
}
.loginSlider .slick-slide{
  height: auto;
}
.loginSlider .slick-list{
  height: 100%;
}
.loginSlider .slick-track{
  display: flex;
  align-items: stretch;
  height: 100%;
}
.loginPageBackground{
  background: linear-gradient(135deg, #E1BEE7, #F8BBD0, #FFE082);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;;;EAGE,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,8DAA8D;AAChE","sourcesContent":[".react-tel-input .form-control {\r\n  height: 2.5rem !important;\r\n  width: 100% !important;\r\n  border: 1px solid #e2e8f0 !important;\r\n  border-radius: 6px !important;\r\n}\r\n\r\n.customTable th {\r\n  background-color: #2d3748;\r\n  color: white !important;\r\n}\r\n\r\n.ql-toolbar {\r\n  border: none !important;\r\n  background-color: #f9f9f9;\r\n  position: sticky;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 9999;\r\n}\r\n.ql-editor {\r\n  height: 100%;\r\n  min-height: 100%;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  border: none;\r\n}\r\n\r\n.ql-editor > p > img {\r\n  display: block !important;\r\n  max-width: 100% !important;\r\n  margin: auto !important;\r\n  margin-top: 10px !important;\r\n  margin-bottom: 10px !important;\r\n}\r\n\r\n.ql-container {\r\n  border: none !important;\r\n}\r\n\r\n.ql-align-center {\r\n  text-align: center !important;\r\n}\r\n.preview_blog_container > div > h2 {\r\n  font-size: 1.2rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.preview_blog_container > div > blockquote {\r\n  border-left: 4px solid #ccc;\r\n  margin-bottom: 5px;\r\n  margin-top: 5px;\r\n  padding-left: 16px;\r\n}\r\n.preview_blog_container > div > p > img {\r\n  margin: auto !important;\r\n}\r\n.preview_blog_container > div > p,\r\nh1,\r\nh2 > img {\r\n  margin: auto !important;\r\n  margin-top: 10px !important;\r\n  margin-bottom: 10px !important;\r\n}\r\n\r\n.preview_blog_container > div > pre {\r\n  white-space: pre-wrap;\r\n  margin-bottom: 5px;\r\n  margin-top: 5px;\r\n  padding: 5px 10px;\r\n}\r\n\r\n.preview_blog_container > div > .ql-syntax {\r\n  background-color: #23241f;\r\n  color: #f8f8f2;\r\n  overflow: visible;\r\n  border-radius: 3px;\r\n  font-size: 13px;\r\n  margin-top: 5px !important;\r\n  margin-bottom: 5px !important;\r\n}\r\n\r\n.preview_blog_container > div > ul, ol {\r\n  padding-left: 2.5em !important;\r\n}\r\n\r\n/* login page slider design */\r\n.loginSlider .slick-slide div {\r\n  height: 100%;\r\n  padding: 0;\r\n}\r\n.loginSlider .slick-slider{\r\n  height: 100%;\r\n}\r\n.loginSlider .slick-slide{\r\n  height: auto;\r\n}\r\n.loginSlider .slick-list{\r\n  height: 100%;\r\n}\r\n.loginSlider .slick-track{\r\n  display: flex;\r\n  align-items: stretch;\r\n  height: 100%;\r\n}\r\n.loginPageBackground{\r\n  background: linear-gradient(135deg, #E1BEE7, #F8BBD0, #FFE082);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
